@let reportHtml = reportHtml$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="secondary">
      <ion-back-button defaultHref="{{defaultBackHref}}/profile/{{profileId}}/report"></ion-back-button>
    </ion-buttons>
    <ion-title>Report Preview</ion-title>
  </ion-toolbar>
</red-header-content>

<ion-content>
  @if (reportHtml) {
  <div class="tw:pt-5" [innerHTML]="reportHtml"></div>
  } @else {
  <div class="tw:flex tw:flex-col tw:gap-2 tw:px-4 tw:py-6">
    <ion-skeleton-text [animated]="true" class="tw:h-4"></ion-skeleton-text>
    <ion-skeleton-text [animated]="true" class="tw:h-4"></ion-skeleton-text>
    <ion-skeleton-text [animated]="true" class="tw:h-4"></ion-skeleton-text>
  </div>
  }
</ion-content>

<div class="tw:absolute tw:bottom-2 tw:left-2/4 tw:-ml-28 tw:flex tw:w-56 tw:justify-center">
  <ion-button color="secondary" shape="round" (click)="exportReport()">
    <ion-icon slot="end" name="download-outline"></ion-icon>
    Download Report
  </ion-button>
</div>
